/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_RecommendedInputs */

const en_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5s (Recommended)`)
};

const fr_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 s (Recommandé)`)
};

const de_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 s (Empfohlen)`)
};

const it_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 secondi (consigliato)`)
};

const ru_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 с (рекомендуется)`)
};

const es_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 s (recomendado)`)
};

const zh_cn2_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5秒（推荐）`)
};

const ja_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5秒（推奨）`)
};

const hi_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 सेकंड (अनुशंसित)`)
};

const pt_pt2_ocr_sampling_recommended = /** @type {(inputs: Ocr_Sampling_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5s (Recomendado)`)
};

/**
* | output |
* | --- |
* | "0.5s (Recommended)" |
*
* @param {Ocr_Sampling_RecommendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_recommended = /** @type {((inputs?: Ocr_Sampling_RecommendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_RecommendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_sampling_recommended(inputs)
	if (locale === "de") return de_ocr_sampling_recommended(inputs)
	if (locale === "it") return it_ocr_sampling_recommended(inputs)
	if (locale === "ru") return ru_ocr_sampling_recommended(inputs)
	if (locale === "es") return es_ocr_sampling_recommended(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_sampling_recommended(inputs)
	if (locale === "ja") return ja_ocr_sampling_recommended(inputs)
	if (locale === "hi") return hi_ocr_sampling_recommended(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_sampling_recommended(inputs)
	return en_ocr_sampling_recommended(inputs)
});